import React from "react";

const PINS = "/icons/Pins";

function Asset({ src, alt, className }) {
  return <img className={className} src={src} alt={alt || ""} draggable={false} />;
}

function Row({ children }) {
  return <div className="v2-marker-legend-row">{children}</div>;
}

/**
 * Legend matching current Figma pin composition:
 * pin colour = Ofsted, fill = gender, child = phase, badge = Grammar / Independent.
 */
export default function MarkerLegend() {
  return (
    <div className="v2-marker-legend">
      <div className="v2-marker-legend-section">
        <div className="v2-marker-legend-heading">Ofsted (pin colour)</div>
        <Row>
          <Asset className="v2-legend-pin-body" src={`${PINS}/Pin_Green.svg`} alt="" />
          <span>Outstanding</span>
        </Row>
        <Row>
          <Asset className="v2-legend-pin-body" src={`${PINS}/Pin_Blue_2.svg`} alt="" />
          <span>Good</span>
        </Row>
        <Row>
          <Asset className="v2-legend-pin-body" src={`${PINS}/Pin_ReqImp_Amber.svg`} alt="" />
          <span>Requires improvement</span>
        </Row>
        <Row>
          <Asset className="v2-legend-pin-body" src={`${PINS}/Pin_InAdeq_Red.svg`} alt="" />
          <span>Inadequate</span>
        </Row>
        <Row>
          <Asset className="v2-legend-pin-body" src={`${PINS}/Pin_NA_Grey.svg`} alt="" />
          <span>Ofsted Unavailable / Independent School</span>
        </Row>
      </div>

      <div className="v2-marker-legend-section">
        <div className="v2-marker-legend-heading">Gender (fill)</div>
        <Row>
          <Asset className="v2-legend-fill" src={`${PINS}/Boys_Fill_New.svg`} alt="" />
          <span>Boys</span>
        </Row>
        <Row>
          <Asset className="v2-legend-fill" src={`${PINS}/Girls_Fill.svg`} alt="" />
          <span>Girls</span>
        </Row>
        <Row>
          <Asset className="v2-legend-fill" src={`${PINS}/Mixed_Fill.svg`} alt="" />
          <span>Mixed</span>
        </Row>
      </div>

      <div className="v2-marker-legend-section">
        <div className="v2-marker-legend-heading">Phase (figure)</div>
        <Row>
          <span className="v2-legend-phase-slot" aria-hidden="true">
            <Asset className="v2-legend-child v2-legend-child--primary" src={`${PINS}/Primary_Child.svg`} alt="" />
          </span>
          <span>Primary School (Left)</span>
        </Row>
        <Row>
          <span className="v2-legend-phase-slot v2-legend-phase-slot--secondary" aria-hidden="true">
            <Asset
              className="v2-legend-child v2-legend-child--secondary"
              src={`${PINS}/Secondary_child.svg`}
              alt=""
            />
          </span>
          <span>Secondary School (Right)</span>
        </Row>
        <Row>
          <span className="v2-legend-phase-slot v2-legend-phase-slot--both" aria-hidden="true">
            <Asset className="v2-legend-child v2-legend-child--primary" src={`${PINS}/Primary_Child.svg`} alt="" />
            <Asset
              className="v2-legend-child v2-legend-child--secondary"
              src={`${PINS}/Secondary_child.svg`}
              alt=""
            />
          </span>
          <span>Primary and Secondary School</span>
        </Row>
      </div>

      <div className="v2-marker-legend-section">
        <div className="v2-marker-legend-heading">School type (badge)</div>
        <Row>
          <Asset className="v2-legend-badge" src={`${PINS}/Badge_G.svg`} alt="" />
          <span>Grammar</span>
        </Row>
        <Row>
          <Asset className="v2-legend-badge" src={`${PINS}/Badge_I.svg`} alt="" />
          <span>Independent</span>
        </Row>
      </div>
    </div>
  );
}
